import {Item} from "../types";
import {useItems} from "../hooks";
import {
    Avatar,
    layout,
    List,
    ListItem,
    ListItemDescription,
    ListItemIcon,
    ListItemName,
    ListItemText,
    MaterialIcon,
    PushButton,
    theme,
    useOccupancies,
    View,
    ViewContent,
    ViewDescription,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {StringUtils} from "@variocube/app-common";
import {useLocalization} from "../../i18n";


interface ItemSelectionViewProps {
    onSelect: (item: Item) => void;
    onCancel: () => void;
}

export function ItemSelectionView({onSelect, onCancel}: ItemSelectionViewProps) {
    const {t} = useLocalization();
    const occupancies = useOccupancies();
    const items = useItems()?.filter(item => !occupancies.find(occupancy => occupancy.content.item == item.uuid));

    return (
        <View>
            <ViewHeader>
                <ViewHeaderItem className={layout.marginYMedium}>
                    <ViewTitle>{t("SelectItem")}</ViewTitle>
                    <ViewDescription>{t("SelectItemDescription")}</ViewDescription>
                </ViewHeaderItem>
                <ViewHeaderItem className={layout.paddingMedium}>
                    <PushButton onClick={onCancel}>
                        {t("Cancel")}
                    </PushButton>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={theme.moreContrast}>
                <List transparent>
                    {items?.map(item => (
                        <ListItemItem key={item.uuid} item={item} onSelect={onSelect}/>
                    ))}
                </List>
            </ViewContent>
        </View>
    );
}

export interface ItemListItemProps {
    item: Item;
    onSelect: (item: Item) => void;
}

function ListItemItem({item, onSelect}: ItemListItemProps) {
    const handleClick = useCallback(() => onSelect(item), [onSelect, item]);
    const abbr = StringUtils.abbreviateInitials(item.name, 3);
    return (
        <ListItem onClick={handleClick}>
            <ListItemIcon>
                <Avatar primary>{abbr}</Avatar>
            </ListItemIcon>
            <ListItemText>
                <ListItemName>{item.name}</ListItemName>
                <ListItemDescription>{item.foreignId}{" "}{item.description}</ListItemDescription>
            </ListItemText>
            <ListItemIcon>
                {MaterialIcon.chevron_right}
            </ListItemIcon>
        </ListItem>
    )
}